<prlw-product-group-filter-mobile-ui
  [selectedItems]="selectedItems$ | async"
  [otherItems]="otherItems$ | async"
  (eventClickX)="eventClose.emit()"
  (eventSelectProductGroup)="selectProductGroup($event)"
  (eventProductGroupSelected)="handleProductGroupSelected($event)"
  (eventProductGroupUnselected)="handleProductGroupUnselected($event)"
>
</prlw-product-group-filter-mobile-ui>
